import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';

const PDPv2Redirect = () => {
  const { pathname, search } = useLocation();

  return (
    <Redirect to={`${pathname.replace('v2/', '')}${search || ''}`} />
  );
};

export default PDPv2Redirect;
